import noframe from 'reframe.js';
export function fluidvideo() {
  noframe('iframe:not([src*="soundcloud.com"])')
}